const indexURL = '/index.html'
const loginURL = '/login'
const previewDocumentURL = '/preview.html'
const updataURL = '/updata.html'
const previewPhototURL = '/photoPreview.html'
// const reflashTime = 1000 * 60 * 30
const config = {
    indexURL,
    loginURL,
    previewDocumentURL,
    updataURL,
    previewPhototURL,
    // reflashTime,
}
export default config